import type {
    Banner,
    ColorVariation,
    Product,
    ProductComparisonBanner,
    SearchContext,
    SimilarProductHeader,
    Slider,
    Variation,
} from '@shared/types/types.ts';

export type SponsoredDisplayAd = {
    type: 'SponsoredDisplayAd';
    searchContext?: SearchContext;
    /*                                                                          */
    hidden?: true;
};

export type TileItem = ProductItem;

export type ProductItem = {
    product: Product;
    variations: Variation[];
    localListPosition: number;
    actualListPosition: number;
    originPosition: number;
    colors?: ColorVariation[];
    currentVariationId?: Variation['variationId'];
    /*                                                                                      */
    variationLoadFailed?: boolean;
    type: 'AS' | 'BOOSTED';
};

export type BenefitCinemaItem = {
    type: 'BenefitCinema';
};

/**
 *
 *
 */
export type BlackFridaySliderItem =
    | { type: 'BlackFridaySlider'; state: 'pending' }
    | { type: 'BlackFridaySlider'; state: 'collapsed' }
    | { type: 'BlackFridaySlider'; state: 'ready'; items: ProductItem[] };

export type TileListItem =
    | SimilarProductHeader
    | Banner
    | Slider
    | ProductComparisonBanner
    | ProductItem
    | SponsoredDisplayAd
    | BenefitCinemaItem
    | BlackFridaySliderItem;

export function isProductItem(item: TileListItem): item is ProductItem {
    return ['AS', 'BOOSTED'].includes(item.type);
}

export function isBlackFridaySliderItem(item: TileListItem): item is BlackFridaySliderItem {
    return item.type === 'BlackFridaySlider';
}
